module.exports = __webpack_public_path__ + "static/media/Overbite (deep bite)6.26693ede.png";